import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("h5", null, "Data: Visible/Selected Molecules", -1);
const _hoisted_2 = {
    key: 0,
    style: { "font-size": "14px" }
};
const _hoisted_3 = {
    key: 1,
    "aria-label": "Tables",
    class: "mb-3"
};
const _hoisted_4 = /*#__PURE__*/ _createTextVNode(" Available tables: ");
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Table = _resolveComponent("Table");
    return (_openBlock(), _createElementBlock("span", null, [
        _hoisted_1,
        (_ctx.allTableData.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, " No molecules (visible or selected) currently have any data to display "))
            : (_ctx.allTableData.length > 1)
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                    _hoisted_4,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTableData, (tableData, idx) => {
                        return (_openBlock(), _createElementBlock("span", {
                            key: tableData[0]
                        }, [
                            _createElementVNode("a", {
                                href: "#",
                                onClick: _withModifiers(($event) => (_ctx.tocLinkScroll(tableData[0])), ["prevent"])
                            }, _toDisplayString(tableData[0]), 9, _hoisted_5),
                            (idx !== _ctx.allTableData.length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, ", "))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128))
                ]))
                : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTableData, (tableData) => {
            return (_openBlock(), _createElementBlock("div", {
                key: tableData[0]
            }, [
                _createVNode(_component_Table, {
                    id: _ctx.slugify(tableData[0]),
                    tableData: tableData[1],
                    caption: tableData[0],
                    noFixedTable: _ctx.noFixedTable(tableData[1]),
                    onRowClicked: _ctx.rowClicked,
                    clickableRows: true
                }, null, 8, ["id", "tableData", "caption", "noFixedTable", "onRowClicked"])
            ]));
        }), 128))
    ]));
}
